module.exports = __webpack_public_path__ + "img/loc-notdistrib.b0e484a2.svg";